export type AddressComponent = {
  longText: string;
  shortText: string;
  types: string[];
};

export type ParsedAddress = {
  street: string;
  city: string;
  state: string;
  postalCode: string;
  country?: string;
};

export const parseAddressComponents = (components: AddressComponent[]): ParsedAddress => {
  const getLong = (type: string): string => components.find((c) => c.types.includes(type))?.longText ?? '';
  const getShort = (type: string): string => components.find((c) => c.types.includes(type))?.shortText ?? '';

  const streetNumber = getLong('street_number');
  const route = getLong('route');
  const city = getLong('locality') || getLong('sublocality') || getLong('administrative_area_level_2');

  const state = getShort('administrative_area_level_1');
  const postalCode = getLong('postal_code');
  const country = getShort('country');

  return {
    street: `${streetNumber} ${route}`.trim(),
    city,
    state,
    postalCode,
    country
  };
};
